import { Subscription } from 'rxjs';
import { ParentProperty } from './../base-models/parent-property';
import { ModelData } from './../base-models/model-data';
import { BaseUpdateComponent } from './base-update-component';
import { ListData } from './../base-models/list-data';
import { BaseEntity } from './../base-models/base-entity';
import { Input, ViewChild, OnInit } from '@angular/core';
import { InlineContainerService } from './containers/services/inline-container.service';
import { QueryParameter } from '../base-models/query-parameter';
import { List } from 'immutable';
export class BaseInlineUpdateComponent<T extends BaseEntity> implements OnInit{
    constructor(protected inlineContainerService: InlineContainerService<T>){
    }

    collapsed: boolean = true;
    saveDisabled: boolean = false;

    @Input() NestedInline: boolean = false;
    
    // Ako container prosleđuje DetailModelData (što ti radiš za dodatne atribute)
    @Input() set DetailModelData(value: ListData) {
        if (!value) {
            return;
        }
        this.setInnerModelData(value);
    }

    // Klasičan slučaj – kao do sada za “obične” inline-ove
    @Input() set ModelData(value: ListData) {
        if (!value) {
            return;
        }
        this.setInnerModelData(value);
    }

    private setInnerModelData(listData: ListData) {
        const modelData = new ModelData(null);
        modelData.MainList = listData;
        this.baseUpdateComponent.ModelData = modelData;
    }

    //@Input() set ParentPropertyName(value: string){
        //this.baseUpdateComponent.parentProperty.Name = value;
    //}

    //@Input() set ParentPropertyValue(value: number){
        //this.baseUpdateComponent.parentProperty.Value = value;
    //}

    @Input() set ParentProperty(value: ParentProperty){
        this.baseUpdateComponent.parentProperty = value;
        this.collapsed = true;
    }
    @Input() set Parameters(value: List<List<QueryParameter>>){
        this.baseUpdateComponent.Parameters = value;
    }

    @ViewChild('baseUpdate', /* TODO: add static flag */ {static: true}) baseUpdateComponent: BaseUpdateComponent<T>;

    private _selectedIDSubscription: Subscription;
    // private _selectedUseridlkSubscription: Subscription;

    ngOnInit(){
        // this.baseUpdateComponent.saveInitialControlDisabledStatus();
        this.inlineContainerService.ActiveComponent.subscribe(activeComponent => {
            if(activeComponent == 'update'){
                this.collapsed = false;
                this.baseUpdateComponent.focus();      
               
                    
            }
        })
        this._selectedIDSubscription = this.inlineContainerService.SelectedID
            .subscribe((ID: number) => {
                if(ID)
                    this.baseUpdateComponent.ID = ID;
            })
      
        // this._selectedUseridlkSubscription = this.inlineContainerService.SelectedUseridlk
        //     .subscribe((Useridlk: number) => {
        //         if(Useridlk && Useridlk > 0)                
        //             this.baseUpdateComponent.baseFormGroup.disable();
        //         else
        //             this.baseUpdateComponent.baseFormGroup.enable();                    
               
        //     })
            
    }

    ngAfterViewInit() {
        if (this.baseUpdateComponent?.ItemSaved) {

            this.baseUpdateComponent.ItemSaved
                .subscribe((item: T) => {
                    this.OnItemSaved(item);
                })
        } else {
            console.warn('BaseInlineUpdateComponent: baseUpdateComponent.ItemSaved je undefined u trenutku AfterViewInit');
        }
    }

    ngOnDestroy(){
        if(this._selectedIDSubscription)
            this._selectedIDSubscription.unsubscribe();
    }

    toggleCollapse(){
        //this.collapsed = !this.collapsed;
    }

    Save(){
        this.saveDisabled = true;
        setTimeout(() => {
            this.saveDisabled = false;
        }, 1000)
        this.baseUpdateComponent.SaveItem();
    }

    OnItemSaved(item: T){
        this.inlineContainerService.EmitItem(item);
        //this.inlineContainerService.ShowList();
        //this.baseUpdateComponent.focus();
        //this.baseUpdateComponent.ID = -1;
    }

    Reset(){
        this.baseUpdateComponent.Reset(true)
            .subscribe(value => {
                if(value){
                    if(this.baseUpdateComponent.Item.ID == -1 || this.baseUpdateComponent.Item.ID == null)
                        this.collapsed = true;
                    this.baseUpdateComponent.submitted = false;
                }
            })

    }

    AddItem(){
        this.inlineContainerService.AddItem();
    }
}